import Cropper from 'cropperjs';

class ImageCropper {
    private cropper: Cropper | null = null;

    private readonly outputWidth = 1320;
    private readonly outputHeight = 500;

    private wrapper = document.getElementById('cover-cropper-wrapper')!;
    private image = document.getElementById('cover-cropper-image') as HTMLImageElement;

    public open(file: File): void {
        const url = URL.createObjectURL(file);

        this.image.onload = () => {
            // 🔍 teraz už má img správne rozmery
            console.log('IMG rect:', this.image.getBoundingClientRect());

            this.cropper?.destroy();

            this.cropper = new Cropper(this.image, {
                aspectRatio: 1320 / 500,
                viewMode: 1,
                dragMode: 'move',
                autoCropArea: 1,
                background: false,
                responsive: true,
                zoomable: true,
                movable: true,
                minContainerWidth: 800,
                minContainerHeight: 600
            });
        };

        this.image.src = url;
        this.wrapper.classList.remove('hidden');
    }

    public save(): void {
        if (!this.cropper) return;

        const canvas = this.cropper.getCroppedCanvas({
            viewMode: 1,
            scalable: false,
            width: 1320,
            height: 500,
            aspectRatio: 1,
            autoCropArea: 1,
            zoomable: false,      // vypne zoom, ako feature
            zoomOnWheel: false,   // vypne scroll zoom
            zoomOnTouch: false,   // vypne pinch zoom (mobile)
            movable: false,
            guides: false,
            dragMode: "none",
        });

        canvas.toBlob(blob => {
            if (!blob) return;

            const file = new File([blob], 'cover.jpg', { type: 'image/jpeg' });

            const livewire = this.getLivewireComponent();
            if (!livewire) return;

            livewire.upload(
                'coverCropped',
                file,
                () => {
                    livewire.dispatch('coverUploaded');
                    this.close();
                },
                (error: any) => {
                    console.error('Upload failed', error);
                }
            );

        }, 'image/jpeg');
    }

    public cancel(): void {
        this.close();
    }

    private close(): void {
        this.cropper?.destroy();
        this.cropper = null;

        this.wrapper.classList.add('hidden');
        this.image.src = '';
    }

    getLivewireComponent(): any {
        const el = document.querySelector('[data-cropper-owner]');
        if (!el) {
            console.error('Cropper owner not found');
            return null;
        }

        const root = el.closest('[wire\\:id]');
        if (!root) {
            console.error('Livewire root not found');
            return null;
        }

        return window.Livewire.find(root.getAttribute('wire:id') as string);
    }
}

export default ImageCropper;